import { Component, OnInit, Input, OnChanges, SimpleChanges, DoCheck } from '@angular/core';
import { IContentElementIframe, QuestionState } from '../models';
import {BrowserModule, DomSanitizer, SafeResourceUrl} from '@angular/platform-browser'

@Component({
  selector: 'element-render-iframe',
  templateUrl: './element-render-iframe.component.html',
  styleUrls: ['./element-render-iframe.component.scss']
})
export class ElementRenderIframeComponent implements OnInit, DoCheck {

  @Input() element:IContentElementIframe;
  @Input() isLocked:boolean;
  @Input() isShowSolution:boolean;
  @Input() questionState:QuestionState;

  urlRaw:string;
  url:SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.updateUrl();
  }

  ngDoCheck() {
    this.updateUrl();
  }

  updateUrl(){
    if (this.urlRaw !== this.element.url){
      this.urlRaw = this.element.url;
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlRaw);
    }
  }

}
